import { render, staticRenderFns } from "./ColumnPropertiesList.vue?vue&type=template&id=153a3a0c&scoped=true&"
import script from "./ColumnPropertiesList.vue?vue&type=script&lang=js&"
export * from "./ColumnPropertiesList.vue?vue&type=script&lang=js&"
import style0 from "./ColumnPropertiesList.vue?vue&type=style&index=0&id=153a3a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a3a0c",
  null
  
)

export default component.exports